import * as React from "react";
import { Footer } from "../components/global/footer/Footer";
import { Header } from "../components/global/header/Header";

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps): JSX.Element => {
  return (
    <div className="min-h-screen w-full min-w-[360px] flex flex-col bg-white overflow-x-hidden" style={{ maxWidth: '100vw' }}>
      <Header />
      <main className="flex-grow w-full overflow-x-hidden pt-[100px]">
        {children}
      </main>
      <Footer />
    </div>
  );
}; 